import { createCustomIcon } from './utils/createCustomIcon';

const InstagramIcon = createCustomIcon({
  displayName: 'InstagramIcon',
  children: (
    <path
      d="M17.5 6.5H17.51M7 2H17C19.7614 2 22 4.23858 22 7V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7C2 4.23858 4.23858 2 7 2ZM16 12A4 4 0 1 0 8 12A4 4 0 1 0 16 12"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});

export default InstagramIcon;
